import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, ButtonGroup } from 'react-bootstrap'
import { serialService } from '../../services/serialService';
import { useAuth } from "../../services/authService";
import { alertService } from "../../services/alertService";
import { Ucfirst } from '../../utils/capitalization';
import { Crud } from "../../helpers/crudAction";
import { Role } from "../../helpers/userRole";

import CrudTable from '../../components/tables/CrudTable';
import ModalView from '../../components/modals/serial/View';
import ModalAdd from '../../components/modals/serial/Add';
import ModalEdit from '../../components/modals/serial/Edit';
import ModalRemove from '../../components/modals/serial/Remove';

const Serial = () => {
    const NAME = "serial";
    const mountedRef = useRef(true);
    const auth = useAuth();
    const [entities, setEntities] = useState(null)

    useEffect(() => {
        listEntities();
        return () => mountedRef.current = false;
    }, []);

    const listEntities = () => {
        serialService.list()
            .then(response => {
                setEntities(response);
            })
            .catch(error => {
                alertService.error(error);
                setEntities([]);
            });
    }

    const tableColumns = [
        {
            dataField: 'number',
            text: 'Number'
        },
        {
            dataField: 'manage',
            text: 'Manage',
            headerAlign: 'right',
            align: 'right',
            formatter: manageFormatter,
        }
    ];

    function manageFormatter(cell, row) {
        if (![Role.SUPER, Role.ADMIN].some(role => auth.user.roles.includes(role))) {
            return <ButtonGroup>
                    <ModalView item={row} />
                </ButtonGroup>
        } else {
            return <ButtonGroup>
                    <ModalEdit item={row} refreshList={refreshList} />
                    <ModalRemove item={row} refreshList={refreshList} />
                </ButtonGroup>
        }
    }

    function refreshList(object, action) {
        switch (action) {
            case Crud.ADD:
                setEntities([...entities, object]);
                alertService.success(Ucfirst(NAME) + ' created successfully');
                break;

            case Crud.EDIT:
                setEntities(entities.map((entity) => (entity.id === object.id ? object : entity)));
                alertService.success(Ucfirst(NAME) + ' updated successfully');
                break;

            case Crud.REMOVE:
                setEntities(entities.filter((entity) => entity.id !== object));
                alertService.success(Ucfirst(NAME) + ' removed successfully');
                break;

            default:
                alertService.warn('Something went wrong');
                break;
        }
    }

    return (
        <>
        <Row>
            <Col>
                <h3 className="text-secondary">{Ucfirst(NAME)}s <ModalAdd refreshList={refreshList} /></h3>
            </Col>
        </Row>
        <Row>
            <Col>
                <CrudTable name={NAME} data={entities} columns={tableColumns} />
            </Col>
        </Row>
        </>
    )
}

export default Serial